<template>
	<div>
		<div class="color-white-c fs-12-c mb-2">
			&nbsp;
		</div>
		<div class="filter-status text-sm">
			<button v-if="showKelolaRekening" :class="buttonRekeningClass" tabindex="-1" @click="changeSetting('rekening')">
				Manage Account
			</button>

			<button :class="buttonProfilClass" tabindex="-1" @click="changeSetting('profil')">
				Profile
			</button>

			<button :class="buttonKepemilikanClass" tabindex="-1" @click="changeSetting('kepemilikan')">
				Payment Method & HIN
			</button>

			<button :class="buttonPasswordClass" tabindex="-1" @click="changeSetting('password')">
				Change Password
			</button>


		</div>
	</div>
</template>

<script>
export default {
	name: 'SettingsNav',
	props: {
		// settingToShow_prop: {
		// 	type: String,
		// 	default: 'rekening'
		// }
	},
	data() {
		return {
			environment: process.env.NODE_ENV,
		}
	},
	computed: {
		accountLevel() {
			return this.$store.getters.getAccountLevel
		},

		settingToShow() {
			return this.$store.state.settingToShow
		},

		activeRekening() {
			return this.settingToShow == 'rekening' ? true : false
		},
		activeProfil() {
			return this.settingToShow == 'profil' ? true : false
		},
		activeKepemilikan() {
			return this.settingToShow == 'kepemilikan' ? true : false
		},
		activePassword() {
			return this.settingToShow == 'password' ? true : false
		},

		buttonRekeningClass() {
			return {
				'c-btn-active': this.activeRekening
			}
		},
		buttonProfilClass() {
			return {
				'c-btn-active': this.activeProfil
			}
		},
		buttonKepemilikanClass() {
			return {
				'c-btn-active': this.activeKepemilikan
			}
		},
		buttonPasswordClass() {
			return {
				'c-btn-active': this.activePassword
			}
		},

		showKelolaRekening() {
			if (this.environment == 'production' || this.$store.getters.getAppName.toLowerCase() == 'pospaygold' || this.$store.getters.paymentMethod == 'gopay') {
				return false
			}
			else {
				return true
			}
		}
	},

	methods: {
		changeSetting(value) {
			this.$store.commit('setSettingToShow_mut', value)
		}
	}
}
</script>

<style scoped>
.filter-status {
	background-color: var(--grey-1-color);
	display: inline-block;
	padding: 2px;
	/* border: 1px solid rgba(255, 255, 255, 0.25); */
	border-radius: 4px;
	height: auto;
	vertical-align: middle;
	padding: 0.375rem;
}

button {
	background-color: var(--grey-1-color);
	color: white;
	border: 0px;
	/*border-radius: 5px;*/
	padding: 5px 15px;
	height: 2.25rem;
	font-weight: 500;
}

button:hover {
	/* background-color: #3b3b56; */
	cursor: pointer;
	filter: brightness(125%);
}

button:active {
	background-color: #2e3d61;
}

.c-btn-active {
	background-color: var(--color-theme);
	border-radius: 2px;
}
</style>